export default {
    strings: {
        // Shown in the status bar while files are being uploaded.
        uploading: 'Uploading',
        // Shown in the status bar once all files have been uploaded.
        complete: 'Complete',
        // Shown in the status bar if an upload failed.
        uploadFailed: 'Upload failed',
        // Shown in the status bar while the upload is paused.
        paused: 'Paused',
        // Used as the label for the button that retries an upload.
        retry: 'Retry',
        // Used as the label for the button that cancels an upload.
        cancel: 'Cancel',
        // Used as the label for the button that pauses an upload.
        pause: 'Pause',
        // Used as the label for the button that resumes an upload.
        resume: 'Resume',
        // Used as the label for the button that resets the upload state after an upload
        done: 'Done',
        // When `showProgressDetails` is set, shows the number of files that have been fully uploaded so far.
        filesUploadedOfTotal: {
            0: '%{complete} of %{smart_count} file uploaded',
            1: '%{complete} of %{smart_count} files uploaded',
        },
        // When `showProgressDetails` is set, shows the amount of bytes that have been uploaded so far.
        dataUploadedOfTotal: '%{complete} of %{total}',
        dataUploadedOfUnknown: '%{complete} of unknown',
        // When `showProgressDetails` is set, shows an estimation of how long the upload will take to complete.
        xTimeLeft: '%{time} left',
        // Used as the label for the button that starts an upload.
        uploadXFiles: {
            0: 'Upload %{smart_count} file',
            1: 'Upload %{smart_count} files',
        },
        // Used as the label for the button that starts an upload, if another upload has been started in the past
        // and new files were added later.
        uploadXNewFiles: {
            0: 'Upload +%{smart_count} file',
            1: 'Upload +%{smart_count} files',
        },
        upload: 'Upload',
        retryUpload: 'Retry upload',
        xMoreFilesAdded: {
            0: '%{smart_count} more file added',
            1: '%{smart_count} more files added',
        },
        showErrorDetails: 'Show error details',
    },
};
